/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { RequestSaleCreateOneSale } from './RequestSaleCreateOneSale'
import {
  RequestSaleCreateOneSaleFromJSON,
  RequestSaleCreateOneSaleFromJSONTyped,
  RequestSaleCreateOneSaleToJSON,
  RequestSaleCreateOneSaleToJSONTyped,
} from './RequestSaleCreateOneSale'
import type { RequestSaleCreateOneItem } from './RequestSaleCreateOneItem'
import {
  RequestSaleCreateOneItemFromJSON,
  RequestSaleCreateOneItemFromJSONTyped,
  RequestSaleCreateOneItemToJSON,
  RequestSaleCreateOneItemToJSONTyped,
} from './RequestSaleCreateOneItem'

/**
 *
 * @export
 * @interface RequestSaleCreateOne
 */
export interface RequestSaleCreateOne {
  /**
   *
   * @type {RequestSaleCreateOneSale}
   * @memberof RequestSaleCreateOne
   */
  sale: RequestSaleCreateOneSale
  /**
   *
   * @type {Array<RequestSaleCreateOneItem>}
   * @memberof RequestSaleCreateOne
   */
  items: Array<RequestSaleCreateOneItem>
}

/**
 * Check if a given object implements the RequestSaleCreateOne interface.
 */
export function instanceOfRequestSaleCreateOne(
  value: object,
): value is RequestSaleCreateOne {
  if (!('sale' in value) || value['sale'] === undefined) return false
  if (!('items' in value) || value['items'] === undefined) return false
  return true
}

export function RequestSaleCreateOneFromJSON(json: any): RequestSaleCreateOne {
  return RequestSaleCreateOneFromJSONTyped(json, false)
}

export function RequestSaleCreateOneFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestSaleCreateOne {
  if (json == null) {
    return json
  }
  return {
    sale: RequestSaleCreateOneSaleFromJSON(json['sale']),
    items: (json['items'] as Array<any>).map(RequestSaleCreateOneItemFromJSON),
  }
}

export function RequestSaleCreateOneToJSON(json: any): RequestSaleCreateOne {
  return RequestSaleCreateOneToJSONTyped(json, false)
}

export function RequestSaleCreateOneToJSONTyped(
  value?: RequestSaleCreateOne | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    sale: RequestSaleCreateOneSaleToJSON(value['sale']),
    items: (value['items'] as Array<any>).map(RequestSaleCreateOneItemToJSON),
  }
}
